(() => {
  window.GiftyQuoteFunnelLoaded = true;
  const push = (payload) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-gifty-quote]').forEach((panel) => {
    if (panel.dataset.quoteBound === 'true') return;
    panel.dataset.quoteBound = 'true';
    const form = panel.querySelector('form');
    const quantityField = panel.querySelector('[data-gqf-quantity]');
    const variantField = panel.querySelector('[data-gqf-variant]');
    const scope = panel.closest('.product__info-container') || document;
    const syncVariant = () => {
      const options = [...scope.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select')].map(input => input.value).filter(Boolean);
      if (variantField && options.length) variantField.value = options.join(' / ');
    };
    const eventData = () => ({lead_type:'product_quote',item_name:panel.dataset.productTitle || '',requested_quantity:Number(quantityField?.value || 0)});
    const success = panel.querySelector('.gqf__success');
    const feedback = success || panel.querySelector('[data-gqf-errors], .errors');
    const resultKey = 'gifty-quote-result:' + location.pathname + ':' + (form?.id || panel.id);
    if (feedback) {
      panel.open = true;
      feedback.setAttribute('tabindex','-1');
      feedback.focus({preventScroll:true});
      if (success) {
        let recorded = false;
        try { recorded = sessionStorage.getItem(resultKey) === 'success'; } catch (_) {}
        if (!recorded) {
          push({event:'generate_lead',...eventData()});
          try { sessionStorage.setItem(resultKey,'success'); } catch (_) {}
        }
      }
    }
    panel.addEventListener('toggle', () => {
      if (!panel.open || feedback) return;
      const productQuantity = scope.querySelector('input[name="quantity"]');
      if (productQuantity && quantityField) quantityField.value = productQuantity.value || quantityField.value;
      syncVariant();
      push({event:'quote_form_open',...eventData()});
    });
    form?.addEventListener('submit', () => {
      syncVariant();
      try { sessionStorage.removeItem(resultKey); } catch (_) {}
      push({event:'quote_form_submit',...eventData()});
    });
  });

  document.querySelectorAll('a[href^="#GiftyQuote-"]').forEach((link) => {
    if (link.dataset.quoteBound === 'true') return;
    link.dataset.quoteBound = 'true';
    link.addEventListener('click', () => {
      const panel = document.getElementById(link.hash.slice(1));
      if (panel?.tagName === 'DETAILS') {
        panel.open = true;
        panel.scrollIntoView({behavior:reduceMotion ? 'auto' : 'smooth',block:'center'});
      }
    });
  });
})();
